<template>
    <section class="select" @mouseleave="closeOptions" :id="id">
        <span class="label">Selecione: {{message}}</span>
        <section class="field">
            <section class="selecteds">
                <span v-for="(item, index) in selecteds" :key="item + index" @click="removeItem(item)">{{item}}</span>
                <input type="text" ref="input" @focus="openOptions"  v-model="search" :disabled="blockLimite ? true : false">
            </section>
        </section>
        <section class="options" v-show="showOptions && !blockLimite"> 
            <ul v-if="filter.length">
                <li v-for="(option, index) in filter" :key="index" @click="selectItem(option)" :ref="'option-'+index" :tabindex="index" @mouseover="clearActive($event)">{{option}}</li>
            </ul>
            <div class="no-result"  v-if="!filter.length">Nenhuma opção encontrada</div>
        </section>
    </section>
</template>

<script>
    export default {
        name: 'select-2',
        components: {},
        props: {
            text: {
                type: String,
                required: false,
            },
            options: {
                type: Array,
                required: false,
            },
            limite: {
                type: Number,
                required: false,
            },
            removeSelectedItem: {
                type: Boolean,
                required: false,
            },
        },
        computed: {
            filter(){
                return this.listOptions.filter(item => {
                    return item.indexOf(this.search) > -1
                })
            },
            listOptions:{
                get: function(){
                    return this.options
                },
                set:function(items){
                   return items.sort()
                }
            },
            blockLimite(){
                return this.selecteds.length >= this.limite ? true : false
            }
        },
        data() {
            return {
                message: '',
                id: null,
                search: '',
                selecteds: [],
                showOptions: false,
                current: 0,
                totalOptions: 0,
            }
        },
        methods: {
            selectItem(option){ 

                if(this.blockLimite) return false

                if(!this.selecteds.includes(option)){
                    
                    this.selecteds = [...this.selecteds, option]
                    this.toggleOptions()
                    this.search = ''
                    this.$refs.input.blur()
                    this.current = 0
                    this.$emit('input', this.selecteds)
                    this.listOptions = this.listOptions.filter(item => item !== option).sort()
                    this.listOptions.sort()
                    
                    if(!this.removeSelectedItem){
                        return false
                    }

                    let index = this.listOptions.indexOf(option)
                    this.$delete(this.listOptions, index);

                }
            },
            removeItem(option){
                this.selecteds = this.selecteds.filter(item => item !== option)
                this.$emit('input', this.selecteds)
                if(!this.removeSelectedItem) return false
                this.listOptions.unshift(option)
                this.listOptions.sort()
                
            },
            toggleOptions(){
                this.showOptions    = !this.showOptions
                this.current        = 0
            },
            closeOptions(){
                this.showOptions    = false
                this.$refs.input.blur()
                this.current        = 0
            },
            openOptions(){
                this.showOptions    = true
                this.current        = 0
                this.totalOptions   = this.options.length 
                if(!this.totalOptions) return false
                this.clearSelecteds()
                this.$refs['option-'+ (this.current)][0].classList.add('active')

            },
            clearSelecteds(){
                if(!this.totalOptions) return false
                this.totalOptions = this.filter.length
                for(var n = 0; n < this.totalOptions; n++){
                    this.$el.querySelectorAll('li')[n].classList.remove('active')
                }
            },
            activeItem(){
                this.$refs['option-'+ (this.current)][0].classList.add('active')
            },
            clearActive(e){
                e.target.classList.remove('active')
            }

        },
        mounted(){

            this.id = 'select-' + this._uid

            this.options.sort()
            this.totalOptions = this.options.length 

            window.addEventListener("keydown", function(e){
                this.totalOptions = this.options.length 
                if(this.showOptions){
                    switch (e.keyCode) {
                        case 38:
                            this.clearSelecteds()
                            this.current--  
                            if(this.current < 0 ){
                                this.current = this.options.length - 1
                            }
                            this.activeItem()
                            break;
                        case 40:
                            this.clearSelecteds()
                            this.current++
                            if(this.current >= this.options.length){
                                this.current = 0
                            }
                            this.activeItem()
                            break;  
                        case 13:
                            var value = this.$el.querySelector('.active').innerHTML
                            this.selectItem(value)
                            break;
                    }

                }

            }.bind(this));


		}
    }
</script>

<style lang="stylus" scoped>
    @import 'styles.styl';
</style>    
